module.exports = __webpack_public_path__ + "img/leizhi.20d77fa4.png";